import { Box, BoxProps, Text } from "@chakra-ui/react";
import { Icon } from "../Icon/Icon";

/**
 * The "this person isn't here to date" line shown where a profile's dating
 * intention would otherwise be. `UserProfile.friendsOnly` is set server-side
 * (and the dating intention withheld) for anyone in Friends Only mode, so
 * without this the section just disappears and the card reads as incomplete
 * rather than as a deliberate choice.
 *
 * Renders the pill only — each surface supplies its own "Looking For" heading
 * in its own type scale.
 */
export const FriendsOnlyNote = (props: BoxProps) => (
  <Box
    borderWidth="2px"
    borderColor="border.friends"
    borderStyle="solid"
    borderRadius="5px"
    paddingX="0.5rem"
    paddingY="0.425rem"
    width="100%"
    alignItems="center"
    lineHeight="100%"
    display="flex"
    justifyContent="flex-start"
    gap="0.5rem"
    {...props}
  >
    <Icon name="smile" boxSize="1.4rem" color="fg.friends" />
    <Text fontSize="0.9rem" color="fg.friends">
      Friends only — not looking to date
    </Text>
  </Box>
);
